import React from "react"
import { useBlocks } from "app/regions/hooks/use-blocks"
import { iconsList as icons } from "./icons-list"
import SelectMenu from "@kit/design/select-menu"
import { OldButton } from "@kit/design/old-button"
import Label from "@kit/design/label"
import TextField from "@kit/design/text-field"

export function IconSettings({ block_id }) {
  const { properties, update, remove } = useBlocks(block_id)

  const handleRemove = () => remove(block_id)

  const options = icons.map(icon => ({
    label: icon.label,
    value: icon.name
  }))

  return (
    <div className="px-4 pb-4">
      <div className="mb-4">
        <Label htmlFor="icon">Icon</Label>
        <SelectMenu
          label="Icon"
          id="icon"
          onChange={e => update({ icon: e.target.value })}
          value={properties.icon}
          className="w-full"
          options={options}
        />
      </div>
      <div className="mb-4">
        <TextField
          label="URL"
          name="url"
          onChange={e => update({ url: e.target.value })}
          value={properties.url || ""}
          placeholder="https://example.com"
        />
      </div>
      <OldButton
        size="sm"
        is="secondary"
        className="ml-auto block"
        onClick={handleRemove}
        icon="delete"
      >
        Remove icon
      </OldButton>
    </div>
  )
}
